import React, { useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import {
    DndContext,
    KeyboardSensor,
    PointerSensor,
    useSensor,
    useSensors,
} from '@dnd-kit/core'
import {
    SortableContext,
    arrayMove,
    sortableKeyboardCoordinates,
} from '@dnd-kit/sortable'
import { Box } from '@mui/material'
import SortableOverlay from './components/sortableOverlay/SortableOverlay'

const VerticalSortableList = ({
    items = [],
    onChange = () => {},
    renderItem = () => {},
}) => {
    const [activeElement, setActiveElement] = useState()

    const activeItem = useMemo(() => items.find(item => item.id === activeElement?.id), [activeElement, items])

    const sensors = useSensors(
        useSensor(PointerSensor),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates,
        }),
    )

    return (
        <DndContext
            sensors={sensors}
            onDragStart={({ active }) => {
                setActiveElement(active)
            }}
            onDragEnd={({ active, over }) => {
                if (over && active.id !== over.id) {
                    const activeIndex = items.findIndex(({ id }) => id === active.id)
                    const overIndex = items.findIndex(({ id }) => id === over.id)

                    onChange(arrayMove(items, activeIndex, overIndex))
                }
                setActiveElement()
            }}
            onDragCancel={() => {
                setActiveElement()
            }}
        >
            <SortableContext items={items}>
                <Box
                    component='ul'
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '0.5rem',
                        padding: '0.5rem 0',
                        margin: 0,
                        listStyle: 'none',
                    }}
                >
                    {items.map((item, index) => (
                        <React.Fragment key={item.id}>{renderItem(item, index)}</React.Fragment>
                    ))}
                </Box>
            </SortableContext>
            <SortableOverlay>
                {activeItem ? renderItem(activeItem) : null}
            </SortableOverlay>
        </DndContext>
    )
}

VerticalSortableList.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        // other item properties
    })).isRequired,
    onChange: PropTypes.func.isRequired,
    renderItem: PropTypes.func.isRequired,
}

export default VerticalSortableList